import styled from "styled-components";

export const RulesDivisionsStyled = styled.div`
  width: 100%;
  padding: 30px;
  border-radius: 20px;
  border: 1px solid #ffffff17;

  .anticon-left {
    color: #fff;
    font-size: 24px;
    &:hover {
      color: #156df2;
    }
  }

  .scroll-content {
    max-height: 600px;
    overflow: auto;
    padding-right: 8px;

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: #0c0d22;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb {
      background: #156df2;
      border-radius: 10px;
    }

    &::-webkit-scrollbar-thumb:hover {
      background: #1259c7;
    }
  }

  .bonus-reward-table {
    .ant-table-content {
      background-color: #0c0d22;
      .ant-table-thead {
        .ant-table-cell {
          background-color: #051847;
          border-bottom: none;
          &:first-child {
            border-top-left-radius: 20px;
          }
          &:last-child {
            border-top-right-radius: 20px;
          }
        }
      }
    }

    .ant-table-cell {
      border-bottom: 1px solid #ffffff17;
      color: #fff;

      &:hover {
        background-color: #0c0d22;
      }

      &.ant-table-cell-row-hover {
        background-color: #0c0d22;
      }
    }
  }
`;
